import {Box, CircularProgress, Divider, MenuItem, TextField, Typography} from "@mui/material";
import React from "react";
import {PartOfSpeech} from "../../../../common/types/words";

export interface PosEditProps {
    currentPos: PartOfSpeech;
    onPosChange: (newPos: PartOfSpeech) => void;
    isLoading: boolean;
}

export const PosEditView = ({currentPos, onPosChange, isLoading} : PosEditProps) => {


    return (
        <Box mb={2}>
            <Divider textAlign="left">
                <Typography variant="h6" align="center">Part of speech</Typography>
            </Divider>
            <TextField
                select
                value={currentPos}
                onChange={(e) => {
                    onPosChange(e.target.value as PartOfSpeech);
                }}
                size="small"
                variant="outlined"
                color="secondary"
                fullWidth={true}
                disabled={isLoading}
                sx={{mt: 1}}
                InputProps={{
                    startAdornment: isLoading && (
                        <Box sx={{display: "flex", alignItems: "center", mr: 1}}>
                            <CircularProgress size={20} />
                        </Box>
                    ),
                }}
            >
                {Object.values(PartOfSpeech).map((pos) => (
                    <MenuItem key={pos} value={pos}>
                        {pos}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
}